import React from 'react';
import Modal from 'react-bootstrap/Modal'
import {useDispatch, useSelector} from "react-redux";
import {deleteWarehouse, setDeleteWarehouseId} from "../../actions/warehouse";

const WarehouseDeleteForm = () => {

    const dispatch = useDispatch();

    const {delete_warehouse, currentPage, numberOfPages, warehouses} = useSelector(state => state.warehouse);

    const closeModal = () =>{
        // removing warehouse user from redux state by sending null setDeleteWarehouseId
        dispatch(setDeleteWarehouseId(null))
    };

    let getPage = null;

    const onConfirm = () =>{

        if ((currentPage === numberOfPages) && (warehouses.length === 1) ){
            getPage = (currentPage - 1);
        }
        else{
            getPage = currentPage;
        }
        dispatch(deleteWarehouse(delete_warehouse.id, getPage))
    };

    let condition = false;
    if(delete_warehouse !== null)
        condition = true;

    return (
        <div>
            <Modal show={condition} onHide={closeModal}>
                <Modal.Header className="bg-danger" closeButton>
                    <Modal.Title className="text-white" >Skladni o'chirish</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Siz haqiqatdan ham ushbu skladni o'chirmoqchimisiz ?
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={closeModal} className="btn btn-secondary">YO'Q</button>
                    <button onClick={onConfirm} className="btn btn-primary">HA</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default WarehouseDeleteForm;